module.exports = __webpack_public_path__ + "static/media/agent-man_.891aa23a.png";